module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_3.9ab2fc23.png";